import {connect} from 'react-redux';
import {compose, lifecycle} from 'recompose';
import {getUserScore} from 'modules/leaderboard/actions';

export default ({force = true, callOnUpdate = true} = {}) =>
  compose(
    connect(),
    lifecycle({
      componentDidMount() {
        const {user, trackSlug, dispatch} = this.props;

        dispatch(
          getUserScore({user_id: user.id, track_slug: trackSlug}, force),
        );
      },
      componentDidUpdate(prevProps) {
        const {
          dispatch,
          trackSlug,
          user: {id: user_id},
        } = this.props;

        if (callOnUpdate || (trackSlug && prevProps.trackSlug !== trackSlug)) {
          dispatch(getUserScore({user_id, track_slug: trackSlug}, force));
        }
      },
    }),
  );
